import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { Avatar, IconButton, Typography } from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CloseIcon from "@mui/icons-material/Close";

import giftCityIcon from "assets/images/svg/logo-dark.svg";
import { useDeleteChatConversionMutation } from "apis/Chatbot";
import colors from "assets/scss/colors.module.scss";
import Tooltip from "Components/Common/Tooltip";

export const ChatbotHeader = ({ chatBotBtnHandler, conversationLength }) => {
  const systemId = localStorage.getItem("deviceToken");

  const [clearChatbotConversion, { isLoading }] =
    useDeleteChatConversionMutation();

  const handleRestartConversion = async () => {
    try {
      await clearChatbotConversion(systemId);
    } catch (error) {}
  };

  const disabled = useMemo(
    () => isLoading || conversationLength === 1,
    [isLoading, conversationLength]
  );

  return (
    <div className="d-flex justify-content-between align-items-center mb-0">
      <Avatar alt="giftCity" src={giftCityIcon} />
      <Typography variant="body1" color="#fff">
        Gujarat International Finance
      </Typography>
      <IconButton disabled={disabled} onClick={handleRestartConversion}>
        <Tooltip title="Restart">
          <RestartAltIcon
            sx={{
              color: disabled ? colors.secondarygrey : colors.white,
            }}
          />
        </Tooltip>
      </IconButton>
      <IconButton onClick={chatBotBtnHandler}>
        <CloseIcon sx={{ color: colors.white }} />
      </IconButton>
    </div>
  );
};

ChatbotHeader.propTypes = {
  chatBotBtnHandler: PropTypes.func,
  conversationLength: PropTypes.number,
};
